import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HeaderComponent } from './components/header/header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DateTimeInputComponent } from './components/date-time-input/date-time-input.component';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BottomNavButtonsComponent } from './components/bottom-nav-buttons/bottom-nav-buttons.component';
import { ImgUploadComponent } from './components/img-upload/img-upload.component';
import { FooterComponent } from './components/footer/footer.component';
import { DurationPipe } from './pipes/duration.pipe';
import { StripeCardComponent } from './components/stripe-card/stripe-card.component';
import { InfluencerProfileCardComponent } from './components/influencer-profile-card/influencer-profile-card.component';
import { MediaListComponent } from './components/media-list/media-list.component';
import { MomentLocalPipe } from './pipes/moment-local.pipe';

@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    DateTimeInputComponent,
    BottomNavButtonsComponent,
    ImgUploadComponent,
    FooterComponent,
    DurationPipe,
    StripeCardComponent,
    InfluencerProfileCardComponent,
    MediaListComponent,
    MomentLocalPipe,
  ],
  imports: [
    CommonModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
  ],
  exports: [
    SidebarComponent,
    HeaderComponent,
    DateTimeInputComponent,
    BottomNavButtonsComponent,
    ImgUploadComponent,
    FooterComponent,
    StripeCardComponent,
    InfluencerProfileCardComponent,
    MediaListComponent,
    DurationPipe,
    MomentLocalPipe
  ],
})
export class SharedModule {}
